import { render, staticRenderFns } from "./UpdateProductCataloguePopUp.vue?vue&type=template&id=404f5fbe&scoped=true&"
import script from "./UpdateProductCataloguePopUp.vue?vue&type=script&lang=js&"
export * from "./UpdateProductCataloguePopUp.vue?vue&type=script&lang=js&"
import style0 from "./UpdateProductCataloguePopUp.vue?vue&type=style&index=0&id=404f5fbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404f5fbe",
  null
  
)

export default component.exports